import React from "react";
// import {  Routes, Route, Link } from 'react-router-dom';
function Search({ searchValue, handleSearch, renderMovies }) {
  return (
    <div>
      <div className="search">
        <div className="header">
          <h3>Movies</h3>
        </div>
        <hr />
        <div className="lower-search">
          <p>Search for movies by their Title</p>
          <input
            type="text"
            placeholder="Search"
            value={searchValue}
            onChange={handleSearch}
          />
          <button id="search-btn" onClick={renderMovies}>
            Search Now !
          </button>
        </div>
      </div>
    </div>
  );
}

export default Search;
